import React from "react";
import { useNavigate } from "react-router-dom";
import { createAttendance, getAllEmployees } from "adminApi/HumanResources/Attendance";
import Spinner from "Common/Globle/Spinner";
import AttendanceForm from "./components/AttendanceForm";
import fields from "../json/Attendance.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import { AttendanceRules } from "validation/ValidationRules";
import { validateForm } from "utils/validation";

const AddAttendance = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors } = useFormChange(
    initialValues,
    AttendanceRules
  );

  // Fetch employees for select
  const { data: employeeData, loading: empLoading } = useFetchAllData(getAllEmployees);

  // Submit Hook
  const { handleSubmit, loading: submitLoading } = useFormSubmit(
    createAttendance,
    (vals) => validateForm(vals, AttendanceRules),
    () => navigate("/admin/attendance"),
    "Attendance recorded successfully!"
  );

  return (
    <>
      {(submitLoading || empLoading) && <Spinner isSpinner={true} />}
      <AttendanceForm
        fields={formdata}
        values={values}
        errors={errors}
        employees={employeeData}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={submitLoading}
        title="Manual Attendance Entry"
      />
    </>
  );
};

export default AddAttendance;
